 export const PositionOptions = [
    // {name:"Manager", value: "manager"},
    // {name:"Executive", value: "executive"},
    // {name:"Team Lead", value: "teamLead"},
    {name:"Teamlead", value: "Teamlead"},
    {name:"Co-Teamlead", value: "Co-Teamlead"},
    {name:"Socialworker", value: "Socialworker"},
    {name:"Other", value: "Other"},
  ]